import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=0cd130bf"
import script from "./Flow.vue?vue&type=script&lang=js"
export * from "./Flow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports